import React from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
// import { RoutePath } from '../../../routes/Routes'
import StateComponents from '../../../../components/state-component/StateComponents'
import { icons } from '../../../../assets/icons/icons'
import { ManageState } from './manageState'
import TableCustom from '../../../../components/table/tableCustom'
import { debouncedApiCall } from '../../../../utils/app.utils'
import { createSearchParams, NavigateFunction, useNavigate } from 'react-router-dom'
import { banner_group_data } from './enum/enum'
import { routeName } from '../../../../routes/routeName'
import { useTranslation } from 'react-i18next'

type Props = {}

const BannerSlide: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation();
    const navigate: NavigateFunction = useNavigate();
    const {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        handleRequestSort,
        sortBy,
        sortType,
        renderData,
        headCell,
        totalItems,
        data,
        setSearch,
        handleChangeDateRange,
        startDate,
        endDate,
        // id_information_source,
        // set_id_information_source,
        checkPermit,
        group_type
    } = ManageState();



    return (
        <ContainerLayout
            title=''
            titleName={t('แบนเนอร์สไลด์')}
            navigateContent={
                <NavigateListCustom
                    navigateData={
                        [
                            {
                                key: "โครงสร้างเว็บไซต์", // i18n-ignore
                                name: t("โครงสร้างเว็บไซต์"),
                                pathName: "",
                                disabled_match: true
                            },
                            {
                                key: "website_structure_banner_slide_list",
                                name: t("แบนเนอร์สไลด์"),
                                pathName: routeName.cms_website.website_structure_banner_slide_list,
                            },
                            {
                                key: "website_structure_banner_slide",
                                name: t(banner_group_data?.find((x) => x.value === group_type)?.label || "-"),
                                pathName: routeName.cms_website.website_structure_banner_slide,
                                searchParams: {
                                    group_type: group_type
                                }
                            },
                        ]}
                />
            }
            content={
                <div className='w-full'>
                    <StateComponents
                        otherProps={{
                            spacing: 2
                        }}
                        typeProps={[
                            {
                                seq: 1,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    startAdornment: <span className='mr-4'><icons.SearchNormal /></span>,
                                    onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: setSearch }),
                                    placeholder: t("ค้นหาชื่อ"),
                                }
                            },
                            // {
                            //     seq: 2,
                            //     type: "AUTO-COMPLETE",
                            //     gridProps: {
                            //         xs: 12,
                            //         md: 3
                            //     },
                            //     fieldProps: {
                            //         getOptionLabel: (op) => op?.label || "",
                            //         labelId: "ALERT_SOURCE",
                            //         options: ALERT_SOURCE_DATA || [],
                            //         value: id_information_source,
                            //         onChange: (_, val) => set_id_information_source(val),
                            //         placeholder: "ทุกแหล่งที่มา",
                            //     }
                            // },
                            {
                                seq: 2,
                                type: "DATE_RANGE2",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    handleChange: handleChangeDateRange,
                                    value: {
                                        end_date: endDate,
                                        start_date: startDate
                                    },
                                    placeholder: t("ช่วงวันที่"),
                                }
                            },
                            {
                                seq: 3,
                                type: "COMPONENT",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    element: <></>
                                }
                            },
                            {
                                seq: 4,
                                type: "BUTTON",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                hidden: !checkPermit.isCreated,
                                fieldProps: {
                                    justifyContent: 'flex-end',
                                    buttonData: [
                                        {
                                            seq: 1,
                                            buttonProps: {
                                                onClick: () => navigate({
                                                    pathname: routeName.cms_website.website_structure_banner_slide_create,
                                                    search: createSearchParams({
                                                        group_type: group_type || ""
                                                    }).toString()
                                                })
                                            },
                                            key: "ADD",
                                            label: t("เพิ่มแบนเนอร์"),
                                            type: "ADD"
                                        }
                                    ]
                                }
                            },
                        ]}
                    />

                    <section className='w-full mt-10'>
                        <TableCustom
                            tableMinWidth={1440}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCell}
                            rowCount={totalItems}
                            rowsData={data?.map((data: any, i: any) => {
                                return renderData(data, i)
                            })}
                            onSort={handleRequestSort}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>

                </div>
            }
        />
    )
}

export default BannerSlide